import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const paymentMethods = [
  { id: 'wallet', name: 'المحفظة', icon: 'ri-wallet-3-line', balance: 450 },
  { id: 'card', name: 'بطاقة ائتمانية', icon: 'ri-bank-card-line' },
  { id: 'apple', name: 'Apple Pay', icon: 'ri-apple-line' },
  { id: 'stc', name: 'STC Pay', icon: 'ri-smartphone-line' },
  { id: 'cash', name: 'الدفع عند الاستلام', icon: 'ri-money-dollar-circle-line' }
];

export default function Payment() {
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState('wallet');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showInsufficientBalance, setShowInsufficientBalance] = useState(false);

  const orderTotal = 207;
  const walletBalance = 450;

  const handlePayment = () => {
    if (selectedMethod === 'wallet' && walletBalance < orderTotal) {
      setShowInsufficientBalance(true);
      return;
    }
    
    setShowSuccess(true);
    setTimeout(() => {
      navigate('/rating');
    }, 2000);
  };

  if (showSuccess) {
    return (
      <div className="min-h-screen bg-[#F6F6F6] flex items-center justify-center px-6">
        <div className="text-center animate-fadeIn">
          <div className="w-24 h-24 bg-[#2E7D32] rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse-soft">
            <i className="ri-check-line text-white text-5xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-[#212121] mb-2">تم الدفع بنجاح!</h2>
          <p className="text-gray-600">جاري التحويل لمتابعة الطلب...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-6 px-6 rounded-b-[30px]">
        <div className="flex items-center gap-3 animate-fadeIn">
          <button onClick={() => navigate(-1)} className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <h1 className="text-xl font-bold text-white">الدفع</h1>
        </div>
      </div>

      {/* Order Summary */}
      <div className="px-6 mt-6">
        <div className="bg-white rounded-2xl p-5 shadow-md animate-slideUp">
          <h3 className="font-bold text-[#212121] mb-4">ملخص الطلب</h3>
          
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">الخدمة</span>
              <span className="text-sm font-semibold text-[#212121]">تمريض منزلي</span>
            </div>
            <div className="h-px bg-gray-100"></div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">الفني</span>
              <span className="text-sm font-semibold text-[#212121]">أحمد محمد</span>
            </div>
            <div className="h-px bg-gray-100"></div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">التاريخ والوقت</span>
              <span className="text-sm font-semibold text-[#212121]">15 يناير، 11:00 ص</span>
            </div>
            <div className="h-px bg-gray-100"></div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">سعر الخدمة</span>
              <span className="text-sm font-semibold text-[#212121]">180 ر.س</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">ضريبة القيمة المضافة</span>
              <span className="text-sm font-semibold text-[#212121]">27 ر.س</span>
            </div>
            <div className="h-px bg-gray-200"></div>
            <div className="flex items-center justify-between pt-2">
              <span className="font-bold text-[#212121]">الإجمالي</span>
              <span className="text-xl font-bold text-[#1565C0]">{orderTotal} ر.س</span>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="px-6 mt-6">
        <div className="bg-white rounded-2xl p-5 shadow-md animate-slideUp stagger-1">
          <h3 className="font-bold text-[#212121] mb-4">طريقة الدفع</h3>
          
          <div className="space-y-3">
            {paymentMethods.map((method) => (
              <button
                key={method.id}
                onClick={() => setSelectedMethod(method.id)}
                className={`w-full flex items-center gap-3 p-4 rounded-xl transition-all ${
                  selectedMethod === method.id
                    ? 'bg-[#1565C0]/10 border-2 border-[#1565C0]'
                    : 'bg-[#F6F6F6] border-2 border-transparent'
                }`}
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                  selectedMethod === method.id ? 'bg-[#1565C0]' : 'bg-white'
                }`}>
                  <i className={`${method.icon} text-xl ${
                    selectedMethod === method.id ? 'text-white' : 'text-gray-600'
                  }`}></i>
                </div>
                <div className="flex-1 text-right">
                  <span className={`block font-semibold ${
                    selectedMethod === method.id ? 'text-[#1565C0]' : 'text-[#212121]'
                  }`}>
                    {method.name}
                  </span>
                  {method.id === 'wallet' && (
                    <span className="text-xs text-gray-500">الرصيد: {method.balance} ر.س</span>
                  )}
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                  selectedMethod === method.id
                    ? 'border-[#1565C0] bg-[#1565C0]'
                    : 'border-gray-300'
                }`}>
                  {selectedMethod === method.id && (
                    <i className="ri-check-line text-white text-xs"></i>
                  )}
                </div>
              </button>
            ))}
          </div>

          {/* Wallet Link */}
          {selectedMethod === 'wallet' && (
            <button
              onClick={() => navigate('/wallet')}
              className="w-full mt-3 flex items-center justify-center gap-2 p-3 bg-[#F6F6F6] rounded-xl text-sm text-[#1565C0] font-semibold hover:bg-[#1565C0]/10 transition-all"
            >
              <i className="ri-add-circle-line"></i>
              <span>شحن المحفظة</span>
            </button>
          )}
        </div>
      </div>

      {/* Card Details (if card selected) */}
      {selectedMethod === 'card' && (
        <div className="px-6 mt-4">
          <div className="bg-white rounded-2xl p-5 shadow-md animate-slideUp stagger-2">
            <h3 className="font-bold text-[#212121] mb-4">تفاصيل البطاقة</h3>
            
            <div className="space-y-3">
              <div>
                <label className="text-sm text-gray-600 mb-2 block">رقم البطاقة</label>
                <input
                  type="text"
                  placeholder="1234 5678 9012 3456"
                  className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm"
                  maxLength={19}
                />
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-sm text-gray-600 mb-2 block">تاريخ الانتهاء</label>
                  <input
                    type="text"
                    placeholder="MM/YY"
                    className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm"
                    maxLength={5}
                  />
                </div>
                <div>
                  <label className="text-sm text-gray-600 mb-2 block">CVV</label>
                  <input
                    type="text"
                    placeholder="123"
                    className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm"
                    maxLength={3}
                  />
                </div>
              </div>
              
              <div>
                <label className="text-sm text-gray-600 mb-2 block">اسم حامل البطاقة</label>
                <input
                  type="text"
                  placeholder="الاسم كما هو مكتوب على البطاقة"
                  className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Insufficient Balance Alert */}
      {showInsufficientBalance && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center px-6 z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm animate-slideUp">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-error-warning-line text-red-500 text-3xl"></i>
            </div>
            <h3 className="text-lg font-bold text-[#212121] text-center mb-2">رصيد غير كافٍ</h3>
            <p className="text-sm text-gray-600 text-center mb-6">
              رصيد المحفظة الحالي: {walletBalance} ر.س<br />
              المبلغ المطلوب: {orderTotal} ر.س
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowInsufficientBalance(false)}
                className="flex-1 bg-gray-100 text-[#212121] py-3 rounded-xl font-semibold"
              >
                إلغاء
              </button>
              <button
                onClick={() => navigate('/wallet')}
                className="flex-1 bg-gradient-to-l from-[#1565C0] to-[#2E7D32] text-white py-3 rounded-xl font-semibold"
              >
                شحن المحفظة
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Pay Button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 p-4 shadow-lg">
        <button
          onClick={handlePayment}
          className="w-full bg-gradient-to-l from-[#1565C0] to-[#2E7D32] text-white py-4 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all active:scale-[0.98]"
        >
          <div className="flex items-center justify-center gap-2">
            <span>ادفع الآن</span>
            <span className="text-lg">{orderTotal} ر.س</span>
          </div>
        </button>
      </div>
    </div>
  );
}
